import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { DashboardMeResponse } from '../models/dashboard.models';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private baseAPI = environment.baseAPI;

  constructor(private http: HttpClient) {}

  getDashboardMe(): Observable<DashboardMeResponse> {
    return this.http.get<DashboardMeResponse>(`${this.baseAPI}/Dashbord/me`);
  }

  getDashboardActivity(params: {
    search?: string;
    status?: string;
    pageNumber?: number;
    pageSize?: number;
  }): Observable<any> {
    let httpParams = new HttpParams();
    if (params.search) {
      httpParams = httpParams.set('search', params.search);
    }
    if (params.status) {
      httpParams = httpParams.set('status', params.status);
    }
    if (params.pageNumber) {
      httpParams = httpParams.set('pageNumber', params.pageNumber.toString());
    }
    if (params.pageSize) {
      httpParams = httpParams.set('pageSize', params.pageSize.toString());
    }

    return this.http.get(`${this.baseAPI}/Dashbord/activity`, {
      params: httpParams,
    });
  }
}

